export const ENV = process.env.VUE_APP_ENV || process.env.NODE_ENV

/**
 * Get endpoint function.
 */

export function getBaseURL () {
  switch (ENV) {
    case 'development':
      return 'http://localhost:8000'
    case 'staging':
      return 'https://stg-twf.admanawards.com'
    case 'production':
      return 'https://admanawards.com'
    default:
      return ''
  }
}

export function getApiBaseURL () {
  if (ENV === 'staging' && process.env.NODE_ENV === 'development') {
    return '/stg-api'
  }

  if (ENV === 'production' && process.env.NODE_ENV === 'development') {
    return '/prod-api'
  }

  // Production is served from both the www and non-www hostnames. Keep API
  // requests on the current origin so the browser does not block them by CORS.
  if (ENV === 'production') {
    return ''
  }

  return getBaseURL()
}

export const getBaseMetaTitle = 'Adman Awards & Symposium'
export const getBaseMetaCurrentYear = '2025'
export const getBaseCurrentYear = '2025'
